let pill_filters = {
          Mytasks: {name: 'Mytasks', display: 'My Tasks', is_active: 1, is_visible: true, count: 0},
          All: {name: 'All', display: 'All', is_active: 1, is_visible: true, count: 0},
          Open: {name: 'Open', display: 'Open', is_active: 0, is_visible: true, count: 0},
          Overdue: {name: 'Overdue', display: 'Overdue', is_active: 0, is_visible: true, count: 0},
          Flagged: {name: 'Flagged', display: 'Flagged', is_active: 0, is_visible: true, count: 0},
          Unassigned: {name: 'Unassigned', display: 'Unassigned', is_active: 0, is_visible: true, count: 0}
}

module.exports = pill_filters